import React from 'react';
import PropTypes from 'prop-types';
import { Hidden } from 'react-grid-system';
import { getLocalizedText as text } from '@vp-dst/localization-util';

import ColorUtil from 'utils/ColorUtil';
import BundleUtil from 'utils/BundleUtil';
import { colors } from 'settings/theme';

import withScreenClass, { withScreenClassPropTypes } from 'components/highOrder/withScreenClass';
import Button from 'components/vistaprintUILibrary/Button';
import TextLink from 'components/vistaprintUILibrary/TextLink';
import Typography from 'components/vistaprintUILibrary/Typography';

function ServiceTileHorizontal(props) {
  const {
    iconSrc,
    title,
    caption,
    highlight,
    iconOnClick,
    buttonOnClick,
    buttonLinkHref,
    screenClass,
    buttonTextOverride,
  } = props;

  const extraSmallScreen = screenClass === 'xs';

  return (
    <div
      style={{
        paddingTop: 20,
        paddingBottom: 25,
        paddingRight: extraSmallScreen ? 20 : 70,
        paddingLeft: extraSmallScreen ? 20 : 20,
        marginBottom: 10,
        marginTop: 15,

        display: 'flex',
        flexDirection: extraSmallScreen ? 'column' : 'row',
        alignItems: 'center',
        justifyContent: extraSmallScreen ? 'center' : 'flex-start',

        borderRadius: 5,
        border: `1px solid ${colors.border}`,
        boxShadow: `0 5px 15px 0 ${ColorUtil.rgbaFromHex(colors.black, 0.05)}, 0 15px 20px 0 ${ColorUtil.rgbaFromHex(colors.shadow, 0.1)}`,
      }}
    >
      <div>
        <button
          type="button"
          style={{
            border: 'none',
            backgroundColor: 'unset',

            marginRight: extraSmallScreen ? 0 : 15,
            marginBottom: extraSmallScreen ? 20 : 0,
          }}
          onClick={iconOnClick}
        >
          <img
            src={BundleUtil.getFullyQualifiedURL(iconSrc)}
            alt={title}
            style={{
              height: extraSmallScreen ? 24 : 48,
            }}
          />
        </button>
      </div>
      <div
        style={{
          minWidth: extraSmallScreen ? 0 : 180,
          paddingRight: extraSmallScreen ? 0 : 40,
        }}
      >
        <Typography
          variant="heading1"
          text={title}
          style={{
            fontSize: '1.75em',
            marginBottom: extraSmallScreen ? 10 : 0,
          }}
        />
        <Typography
          text={caption}
          style={{
            fontSize: '1em',
            marginBottom: extraSmallScreen ? 25 : 0,
            textAlign: extraSmallScreen ? 'center' : 'left',
          }}
        />
      </div>
      <Hidden xs>
        <div
          style={{
            minWidth: extraSmallScreen ? 0 : 180,
            paddingRight: extraSmallScreen ? 0 : 40,
            textAlign: extraSmallScreen ? 'center' : 'left',
          }}
        >
          <Typography
            text={highlight}
            style={{
              fontSize: '1.2em',
              marginBottom: extraSmallScreen ? 20 : 0,
            }}
          />
        </div>
      </Hidden>
      <div
        style={{
          textAlign: extraSmallScreen ? 'center' : 'left',
          marginLeft: extraSmallScreen ? 0 : 'auto', // push this div to the right side of the container on larger screens
        }}
      >
        {!extraSmallScreen
          && (
            <Button
              variant="primary"
              iconName="arrow-r"
              text={buttonTextOverride || text('get-started')}
              onClick={buttonOnClick}
            />
          )
        }
        {extraSmallScreen
          && (
            <TextLink
              text={buttonTextOverride || text('get-started')}
              href={buttonLinkHref}
            />
          )
        }
      </div>
    </div>
  );
}

ServiceTileHorizontal.propTypes = {
  iconSrc: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  caption: PropTypes.string.isRequired,
  highlight: PropTypes.string.isRequired,
  iconOnClick: PropTypes.func.isRequired,
  buttonOnClick: PropTypes.func.isRequired,
  buttonLinkHref: PropTypes.string.isRequired,
  ...withScreenClassPropTypes,
};

export default withScreenClass(ServiceTileHorizontal);



// WEBPACK FOOTER //
// ./src/components/ServiceTileHorizontal.js